import { useEffect, useState } from "react";
import styles from "../styles/AccountView.module.css";
import { API_URL } from "../config/api";

const AccountView = () => {
  const [account, setAccount] = useState(null);
  const [roleTitle, setRoleTitle] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        // Получаем аккаунт
        const accRes = await fetch(`${API_URL}/api/account`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const accData = await accRes.json();
        setAccount(accData.data);

        // Получаем роли
        const roleRes = await fetch(`${API_URL}/api/roles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const roleData = await roleRes.json();

        // Находим роль пользователя
        const role = roleData.data?.find(
          (r) => r.id === accData.data?.role_id
        );

        setRoleTitle(role ? role.title : "Неизвестно");
      } catch (err) {
        console.error("Ошибка загрузки аккаунта или ролей", err);
      }
    };

    fetchData();
  }, []);

  if (!account)
    return <p className={styles.loading}>Загрузка данных...</p>;

  return (
    <div className={styles.container}>
      <h1>Личный кабинет</h1>

      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.avatar}>
            {(account.name?.[0] || "") +
              (account.surname?.[0] || "")}
          </div>

          <div className={styles.userInfo}>
            <h2>
              {account.name} {account.surname}
            </h2>
            <span className={styles.role}>{roleTitle}</span>
          </div>
        </div>

        <div className={styles.section}>
          <h3>Личная информация</h3>

          <div className={styles.row}>
            <span>Email:</span>
            <span>{account.email}</span>
          </div>

          <div className={styles.row}>
            <span>Телефон:</span>
            <span>{account.phone}</span>
          </div>

          <div className={styles.row}>
            <span>Статус:</span>
            <span
              className={
                account.status === "active"
                  ? styles.active
                  : styles.inactive
              }
            >
              {account.status}
            </span>
          </div>
        </div>

        <div className={styles.section}>
          <h3>Организация</h3>

          <div className={styles.row}>
            <span>Название:</span>
            <span>{account.org?.name}</span>
          </div>

          <div className={styles.row}>
            <span>БИН:</span>
            <span>{account.org?.sn}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountView;
